<template>
    <div>
        <h4 class="font-weight-bold my-3">Enter Verification Code</h4>
        <h5 class="mb-3">
            A verification code has been sent to your email address: <span class="font-weight-bold">{{ email }}</span>.
            <br>
            Please enter your code below.
        </h5>
        <div v-if="message" class="text-danger my-3">{{ message }}</div>
        <pincode-input name="verification_code" v-model="verificationCode" :length="6" :character-preview="false" />                          
        <div class="mt-3">
            <button type="submit" class="btn btn-primary" @click="submit()">Verify</button>
        </div>
    </div>
</template>

<script>
import PincodeInput from 'vue-pincode-input';
export default {
    components: {
        PincodeInput
    },
    props: {
        action: String,
        signature: String,
        email: String
    },
    data() {
        return {
            message: null,
            verificationCode: ''
        }
    },
    methods: {
        submit: function () {
            let self = this;
            axios.post(self.action, {
                email_signature: self.signature,
                verification_code: self.verificationCode                
            })
            .then(response => {
                if (response.data.message) {
                    // display message to user
                    self.message = response.data.message;
                }
                else {
                    // go to the download page
                    window.location = response.data.url;
                }                
            })
            .catch(error => {
                // go to the secure download error page
                window.location = error.response.data;
            });                       
        }
    }       
}
</script>

<style scoped>
    input.vue-pincode-input {
        margin: 3px;
        padding: 5px;
        max-width: 40px;
        text-align: center;
        font-size: 1.1rem;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
        -webkit-transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
        box-shadow: none;               
    }

    input.vue-pincode-input:focus {
        background-color: #fff;
        border-color: #249eef;
        outline: 0;
        box-shadow: 0 0 0 0.2rem rgba(10, 87, 138, 0.25); 
    }
</style>